module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-d1331793.png";